import keys from 'lodash/keys';

import NutritionTableContentRow from 'components/mealDetails/nutritionFacts/NutritionTableContentRow';
import {
  getNutritionFactInfoLegend,
  VITAMIN_INFO_LEGEND,
  NO_PERCENT_DATA_REQUIRED,
  ADDED_SUGARS,
} from 'lib/constants';
import style from 'styles/components/mealDetails/NutritionFactsPanel.module.scss';

const NutritionTableContentRows = ({
  needsAllNutritionDetails,
  dailyPercentAsPackaged,
  dailyPercentAsPrepared,
  dailyValueAsPackaged,
  dailyValueAsPrepared,
  isTempo,
}) => {
  const displayValues = isTempo ? dailyValueAsPrepared : dailyValueAsPackaged;
  const displayPercentages = isTempo ? dailyPercentAsPrepared : dailyPercentAsPackaged;

  return (
    <>
      <tbody className={style.nutritionTableBody}>
        <tr className={style.columnHeaders}>
          <th scope="col">
            <span className="sr-only">Nutrient type</span>
          </th>

          <th className={style.tdGrams} scope="col">
            <span className="sr-only">
              {`Nutrient amount by weight, ${isTempo ? 'as prepared' : 'packaged'}`}
            </span>
          </th>
          <th className={style.tdPercent} scope="colgroup">
            <span className="sr-only">
              {`Nutrient amount by percent of daily requirement, ${isTempo ? 'as prepared' : 'packaged'}`}
            </span>
            <span
              className="whitespace-nowrap"
              title="The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice."
            >
              % {needsAllNutritionDetails ? 'DV' : 'Daily Value'}
              <sup>*</sup>
            </span>
          </th>

          {needsAllNutritionDetails && (
            <>
              <th className={style.tdGrams} scope="col">
                <span className="sr-only">Nutrient amount by weight, as prepared</span>
              </th>
              <th className={style.tdPercent} scope="col">
                <span className="sr-only">
                  Nutrient amount by percent of daily requirement, as prepared
                </span>
                <span
                  className="whitespace-nowrap"
                  title="The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice."
                >
                  % DV<sup>*</sup>
                </span>
              </th>
            </>
          )}
        </tr>
        {getNutritionFactInfoLegend(!needsAllNutritionDetails).map(group =>
          keys(group).map(slug => {
            if (slug === 'groupTitle') return null;
            return (
              <NutritionTableContentRow
                displayPercent={!NO_PERCENT_DATA_REQUIRED.includes(slug)}
                displayPreparedNutritionInfo={needsAllNutritionDetails}
                isHeader={group.groupTitle === slug}
                key={slug}
                percentAsPackaged={displayPercentages[slug]}
                percentAsPrepared={dailyPercentAsPrepared[slug]}
                rowClass={style.nutrientRow}
                title={group[slug]}
                valueAsPackaged={displayValues[slug]}
                valueAsPrepared={dailyValueAsPrepared[slug]}
                addedSugarsRow={slug === ADDED_SUGARS}
              />
            );
          })
        )}
      </tbody>
      <tbody>
        {VITAMIN_INFO_LEGEND.map(group =>
          keys(group).map(slug => (
            <NutritionTableContentRow
              displayPercent={true}
              displayPreparedNutritionInfo={needsAllNutritionDetails}
              isHeader={false}
              key={slug}
              percentAsPackaged={displayPercentages[slug]}
              percentAsPrepared={dailyPercentAsPrepared[slug]}
              rowClass={style.vitaminRow}
              title={group[slug]}
              valueAsPackaged={displayValues[slug]}
              valueAsPrepared={dailyValueAsPrepared[slug]}
              addedSugarsRow={false}
            />
          ))
        )}
      </tbody>
    </>
  );
};

NutritionTableContentRows.propTypes = {
  needsAllNutritionDetails: PropTypes.bool.isRequired,
  dailyPercentAsPackaged: PropTypes.object.isRequired,
  dailyPercentAsPrepared: PropTypes.object.isRequired,
  dailyValueAsPackaged: PropTypes.object.isRequired,
  dailyValueAsPrepared: PropTypes.object.isRequired,
  isTempo: PropTypes.bool.isRequired,
};

export default NutritionTableContentRows;
